import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import KeyFeatureAndTopBenefits from "./KeyFeatureAndTopBenefits";
import Transactions from "../common/Transactions";
import Advertisement from "../common/Advertisement";
import TabComponent from "../common/TabComponent";
import ServiceAmount from "./ServiceAmount";
import ServiceStatus from "./ServiceStatus";
import UsageReport from "./UsageReport";
import InvoiceList from "./InvoiceList";

const ServiceSpecific = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { title } = location.state || {}; // No default title
  const { serviceId } = location.state || {};
  const { serviceName } = location.state || {};
  const [activeTab, setActiveTab] = useState("tab1");

  const renderContent = () => {
   
    switch (activeTab) {
      case "tab1":
        return (
          <>
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => {
                  // Open external portal in new tab without navigating away from MASS.
                  window.open("https://smr.rezo.ai", "_blank", "noopener,noreferrer");
                }}
              >
                View of Leads and PSF Feedback
              </button>
            </div>
            <KeyFeatureAndTopBenefits serviceName={serviceId} />
          </>
        );
      case "tab2":
        return <ServiceAmount serviceName={serviceId} svcName={serviceName}/>;
      case "tab3":
        return (
          <div>
            <ServiceStatus serviceName={serviceId}/>
          </div>
        );
      case "tab4":
        return <UsageReport serviceName={serviceId}/>;
      case "tab5":
        return <InvoiceList serviceName={serviceId}/>;
      default:
        return <KeyFeatureAndTopBenefits title={title} />;
    }
  };

  return (
    <main className="container-fluid" style={{ padding: "8px" }}>
      <div
        className="row p-2 rounded"
        style={{ backgroundColor: "rgb(244 244 244)" }}
      >
        {/* Mobile View */}
        <div className="col-12 order-1 d-md-none">
          <TabComponent
            title={t(title)}
            tabs={[
              { key: "tab1", label: t("service_overview") },
              { key: "tab2", label: t("service_amount") },
              { key: "tab3", label: t("service_status") },
              { key: "tab4", label: t("report_s") },
              { key: "tab5", label: t("invoice_s") },
            ]}
            onTabChange={(tabKey) => setActiveTab(tabKey)}
          />
        </div>
        <div className="col-11 order-2 d-md-none mx-auto text-center"style={{width: '100%'}}>
          {renderContent()}
        </div>
        <div className="col-11 order-3 d-md-none mx-auto">
          <Transactions />
        </div>
        <div className="col-11 order-4 d-md-none mx-auto">
          <Advertisement />
        </div>

        {/* Desktop View */}
        <div className="col-md-8 order-md-1 d-none d-md-block p-4">
          <TabComponent
            title={t(title)}
            tabs={[
              { key: "tab1", label: t("service_overview") },
              { key: "tab2", label: t("service_amount") },
              { key: "tab3", label: t("service_status") },
              { key: "tab4", label: t("report_s") },
              { key: "tab5", label: t("invoice_s") },
            ]}
            onTabChange={(tabKey) => setActiveTab(tabKey)}
          />
          {renderContent()}
        </div>
        <div className="col-md-4 order-md-2 d-none d-md-block p-4">
          <Transactions />
          <Advertisement />
        </div>
      </div>
    </main>
  );
};

export default ServiceSpecific;
